export default {
  fromLabel: {
    display: 'inline-block',
    marginRight: 10,
    marginBottom: 30,
  },
};
